<template>
  <mastery-modal
    :header-image="attachment"
    name="mastery-transition"
    :primary-action-text="primaryButtonText"
    :secondary-action-text="secondaryButtonText"
    :title="title"
    :type="modalType"
    @before-open="beforeOpen"
    @primary-action-clicked="primaryAction"
    @secondary-action-clicked="secondaryAction"
  >
    <div v-html="content" />
  </mastery-modal>
</template>

<script>
import MasteryModal from '@components/ui/masteryModal';
import { MODALS, recordTransitionMessageSeen } from '@/utils/transition';
import { startTransitionQuestionnaire } from '@/utils/questionnaire';

export default {
  components: { MasteryModal },
  data() {
    return {
      config: null,
    };
  },
  computed: {
    attachment() {
      if (this.config?.attachment_id) {
        return this.$store.getters['attachments/get'][this.config.attachment_id];
      }
    },
    content() {
      if (this.config?.text_html) {
        const matches = this.config.text_html.match(/{first_name\|.*}/);
        if (matches) {
          const defaultValue = matches[0] && matches[0].split('|')[1].substring(0, matches[0].split('|')[1].length - 1);
          // replace bracket area with first name
          return this.config.text_html.replace(/{first_name\|.*}/, this.$store.getters['session/currentUser'].firstName || defaultValue);
        }

        return this.config.text_html;
      }
    },
    modalType() {
      return this.config?.key === MODALS.MESSAGE_4 ? 'masteryModalBlue' : 'masteryModalWhite';
    },
    primaryButtonText() {
      return this.config?.primary_button_text;
    },
    secondaryButtonText() {
      return this.config?.secondary_button_text;
    },
    title() {
      return this.config?.title;
    },
  },
  created() {
    if (this.config?.attachment_id) {
      this.$store.dispatch('attachments/fetch', { ids: [this.config.attachment_id ]});
    }
  },
  methods: {
    beforeOpen(event) {
      this.config = event.params;
      recordTransitionMessageSeen(this.config.key, this.$store.getters['session/currentUser']);
      this.$analytics.events.viewedTransitionMessage({
        promptName: event.params['prompt_name'],
      });
    },
    close() {
      this.$modal.hide('mastery-transition');
    },
    primaryAction() {
      if (this.config?.topic_id) {
        this.$router.push({ name: 'deeplinks#topic', params: { topicId: this.config.topic_id }});
      } else if (this.config?.key === MODALS.MESSAGE_3) {
        startTransitionQuestionnaire.apply(this);
      }
      this.close();
    },
    secondaryAction() {
      this.close();
    },
  },
};
</script>
